import { render, staticRenderFns } from "./VueSwitch.vue?vue&type=template&id=2122e5da&"
import script from "./VueSwitch.vue?vue&type=script&lang=js&"
export * from "./VueSwitch.vue?vue&type=script&lang=js&"
import style0 from "./VueSwitch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports